import React, { useEffect, useState } from 'react';
import InputGenerico from '../inputGenerico/inputGenerico';
import SelectGenerico from '../selectGenerico/selectGenerico';
import { Form, InputGroup } from 'react-bootstrap';

interface SegundoFormularioProps {
  formValues: {
    cdAnuncio?: string;
    nmAnuncio: string;
    dtPublicacao: string;
    vlAnuncio: string;
    cdCidade: string;
    dmAtivo?: boolean;
    [key: string]: any;
  };
  handleFieldChange: (field: string, value: any) => void;
  validacaoAtiva: boolean;
  cidades: { cdCidade: string | number; nmCidade: string; }[];
  anuncio?: { dmAtivo?: boolean; dtPublicacao?: string };
  idPagina?: string;
}

const formatCurrency = (value: string) => {
  return parseFloat(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

const dataAtual = new Date().toLocaleDateString('en-CA');

const SegundoFormulario: React.FC<SegundoFormularioProps> = ({ formValues, handleFieldChange, validacaoAtiva, cidades, anuncio, idPagina }) => {

  const dataAnuncio = formValues.dtPublicacao;
  const data = ((dataAnuncio <= dataAtual && !(anuncio?.dtPublicacao && anuncio?.dtPublicacao > dataAtual) && anuncio?.dmAtivo === false && idPagina));

  return (
    <div className="estiloGeral subbloco01 shadow-sm p-3 bg-light rounded">
      <InputGenerico
        name="nmAnuncio"
        value={formValues.nmAnuncio}
        onChange={(event) => handleFieldChange(event.target.name, event.target.value)}
        label="Nome do Anúncio"
        placeholder="Digite aqui..."
        type="text"
        className={`form-control mt-0 ${validacaoAtiva && !formValues.nmAnuncio ? 'input-invalid' : ''}`}
      />

      <InputGenerico
        name="dtPublicacao"
        value={formValues.dtPublicacao}
        onChange={(event) => handleFieldChange(event.target.name, event.target.value)}
        label="Data de Publicação"
        placeholder="Digite aqui..."
        type="date"
        disabled={(anuncio && anuncio?.dmAtivo || data) ? true : false}
        validacaoAtiva={true}
        className={`form-control ${validacaoAtiva && !formValues.dtPublicacao ? 'input-invalid' : ''}`}
        min={dataAtual}
      />

      <div>
        <label htmlFor="vlAnuncio" className='mb-2'>Valor</label>
        <InputGroup className={`mb-1`}>
          <InputGroup.Text className={`${(validacaoAtiva && !formValues.vlAnuncio) || (validacaoAtiva && formValues.vlAnuncio === '0') ? 'input-invalid' : ''}`}>
            {formValues.vlAnuncio ? formatCurrency(formValues.vlAnuncio) : '0,00'}
          </InputGroup.Text>
          <Form.Control
            name="vlAnuncio"
            value={formValues.vlAnuncio}
            onChange={(event) => handleFieldChange(event.target.name, event.target.value)}
            aria-label="Dollar amount (with dot and two decimal places)"
            type="number"
            step="0.01"
            placeholder="Digite aqui..."
            className={`${(validacaoAtiva && !formValues.vlAnuncio) || (validacaoAtiva && formValues.vlAnuncio === '0') ? 'input-invalid' : ''}`}
            id='vlAnuncio'
            min={0}
          />
        </InputGroup>
      </div>
      <SelectGenerico
        opcoes={cidades && cidades.map((cidade) => ({
          valor: cidade.cdCidade,
          rotulo: `${cidade.nmCidade}`,
        }))}
        valorSelecionado={formValues.cdCidade}
        onChange={(value: string | number) => handleFieldChange('cdCidade', value)}
        label="Cidade"
        opcaoPadrao='Selecione a cidade...'
        classe={`form-select mt-0 dropdown-content ${validacaoAtiva && !formValues.cdCidade ? 'select-invalid' : ''}`}
      />
    </div>
  );
};

export default SegundoFormulario;
